var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7402_34685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00342 9.90044C4.00195 8.18446 5.39003 6.79785 7.10895 6.79785C8.82053 6.79785 10.2115 8.18005 10.2145 9.88721C10.2189 11.6017 8.82935 12.9957 7.11484 13.0001C5.40032 13.0045 4.00489 11.615 4.00195 9.90044H4.00342ZM6.39286 10.7856C6.14436 10.4857 5.91203 10.1975 5.67088 9.91515C5.62677 9.86221 5.55766 9.80781 5.49443 9.80192C5.44297 9.79751 5.35033 9.85339 5.3371 9.89897C5.31945 9.9622 5.33857 10.0578 5.37974 10.1107C5.63118 10.4298 5.89145 10.7401 6.15024 11.0533C6.3061 11.2415 6.42668 11.2473 6.60754 11.0724C7.17365 10.5268 7.73977 9.97985 8.30588 9.43432C8.48674 9.25934 8.66907 9.08436 8.84846 8.90644C8.9264 8.8285 8.93375 8.73734 8.85435 8.65646C8.77641 8.57706 8.68525 8.58294 8.60143 8.65205C8.55585 8.69028 8.51468 8.7344 8.47204 8.77557C7.78094 9.44167 7.09131 10.1092 6.38992 10.7856H6.39286Z",
    fill: "#16C06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67805 10.4032C3.61776 10.4032 3.57365 10.4032 3.52953 10.4032C2.41201 10.4032 1.29302 10.4017 0.175502 10.4062C0.0402232 10.4062 0.000521785 10.3709 0.00199221 10.2312C0.00787389 9.17689 0.00346263 8.1226 0.00493305 7.0683C0.00787389 5.78757 0.926888 4.86855 2.20468 4.86561C3.22957 4.86414 4.25298 4.8612 5.27787 4.86561C6.19835 4.87002 6.97767 5.4082 7.29087 6.24193C7.31293 6.30074 7.3291 6.3625 7.35263 6.44043C6.25276 6.39779 5.3161 6.74922 4.57206 7.54913C3.83097 8.3461 3.54571 9.29893 3.67805 10.4003V10.4032Z",
    fill: "#344051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71345 2.00423C5.70315 3.13793 4.81355 4.01577 3.68427 4.00547C2.58586 3.99518 1.7139 3.0894 1.72272 1.96747C1.73155 0.882298 2.63732 -0.00730686 3.72691 4.52458e-05C4.82531 0.00739735 5.72227 0.911707 5.71345 2.00423Z",
    fill: "#344051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7402_34685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.215,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoined);
export default __webpack_public_path__ + "static/media/joined.2f1a18ea8f3336dd8bfcf1bbb66cf315.svg";
export { ForwardRef as ReactComponent };